export const orderItemsPreviewFilter = {
  name: "orderItemsPreviewFilter",
  criterions: [
    {
      extension: null,
      placeholder: "",
      width: 200,
      value: null,
      type: "TextCriterion",
      extensionType: null,
      extensionValue: null,
      ordinate: 1,
      label: "Szukaj",
      propertyName: "OrderItemsPreviewSearch",
      canDelete: true,
      isRequired: false,
      isVisible: true,
      tooltip: "",
    },
  ],
};
